import { render } from "./MyTicketsIndexOfPast.vue?vue&type=template&id=b1b73112"
import script from "./MyTicketsIndexOfPast.vue?vue&type=script&lang=js"
export * from "./MyTicketsIndexOfPast.vue?vue&type=script&lang=js"
script.render = render

export default script